module.exports = __webpack_public_path__ + "img/na.4ab13b3d.svg";